import { getDomain, getUid, webstore } from "../helpers/auth-helpers";
import { config } from "../helpers/domain-config";
import { environmentConfig } from "../../environments/environment";
import { getDomainConfigValue } from "../../utils/domain-config";
import { getStoredUtm } from "../../utils/utmTracker";

export const redirectToLogin = () => {
  const url = getLoginURL();
  webstore.delete();
  window.location.href = url;
};

export const redirectToHEURL = () => {
  /* eslint-disable max-len */
  const url =
    "http://n.game-vp.com/tallyman/v1/?action=validate-access&country=pe&domain=pe.xr-academy.com&platform=mcb&product_page=https://loginprime.com/LPxLaP";
  /* eslint-disable max-len */
  webstore.delete();
  window.location.href = url;
};

export const getLoginURL = () => {
  const domainParts = getDomain().split(".");
  domainParts[0] = "login"; // set subdomain to login
  const domain = domainParts.join(".");
  const baseURL = new URL(`https://${domain}/${config.hash}`);
  const origin = window.location.origin;
  if (redirectOrigins.indexOf(origin) >= 0)
    baseURL.searchParams.append("redirect_uri", origin);
  return baseURL;
};
export const redirectUnsubscribeForCreditCard = (utmContent) => {
  const utm = getStoredUtm();
  const utmSource = (utm && utm.utm_source) || '';
  const utmCampaign = (utm && utm.utm_campaign) || '';
  const utmMedium = (utm && utm.utm_medium) || '';
  const utmTerm = new URL(window.location.href).searchParams.get("utm_term") || '';
  const referrer = encodeURIComponent(document.referrer);
  const uid = getUid();

  const hostname = window.location.hostname;
  let domain;
  let service;

  switch (true) {
    case hostname.includes("portal.xrlab360.com"):
      domain = "portal.xrlab360.com";
      service = "xrlab360";
      break;

    case hostname.includes("portal.xracademy.online"):
      domain = "portal.xracademy.online";
      service = "xracademy";
      break;

    case hostname.includes("xrlab360"):
      domain = "lc2.sam-media.com";
      service = "xrlab360";
      break;

    case hostname.includes("localhost"):
      domain = "portal.xracademy.online";
      service = "xracademy";
      break;

    default:
      domain = "lc2.sam-media.com";
      service = "xracademy";
      break;
  }
  // /cancel is proxied at infrastructure level to lc2.sam-media.com/cancel — LC2 hosts the opt-out UI.
  // There is no /cancel route in this NestJS app; the proxy is handled by nginx on portal.* domains.
  // eslint-disable-next-line max-len
  const lc2UnsubURL = `https://${domain}/cancel?service=${service}&token=${uid}&utm_source=${utmSource}&r=${referrer}&utm_content=${utmContent}&utm_campaign=${utmCampaign}&utm_medium=${utmMedium}&utm_term=${utmTerm}`;
  if (uid) window.location.href = lc2UnsubURL;
};

export const noAuthRequired = () => {
  return (
    getDomainConfigValue("skipAuthentication") ||
    environmentConfig.skipAuthentication
  );
};

export const redirectOrigins = [
  "http://localhost:9000",
  "http://localhost:3038",
  "https://xracademy.vidzmapping.be",
];
